// extracted by mini-css-extract-plugin
export default {"container":"about_container__24RiM","block":"about_block__1C7Jq"};